import React from "react";
function Contact() {
  return (
    <div className="container mt-4 zoom-in">
      <div className="card p-4 shadow">
        <h2>Contact Us</h2>
        <p>Email: support@velvetHorizonevents.com</p>
        <p>Phone: +91 7095343123</p>
      </div>
    </div>
  );
}
export default Contact;